import httpClient from "Api/httpClient";

const END_POINT = "/tags";

const getTags = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body });
    // if (body.company_id) {
    //     const GET_END_POINT = END_POINT + "?company_id=" + body.company_id;
    //     return httpClient.get(GET_END_POINT, { retryTimes: 3 }); // useCahe: true, retryTimes: 3, throttle: true
    // } else {
    //     return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
    // }
};

const getTag = (tag_id) => {
    if (!tag_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + tag_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printTag = (tag_id) => {
    if (!tag_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?tag_id=" + tag_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createTags = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateTags = (payload, tag_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + tag_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteTags = (tag_id) => {
    const DELETE_END_POINT = END_POINT + "/" + tag_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getTags, getTag, printTag, createTags, updateTags, deleteTags };
